import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import isEmpty from 'lodash/isEmpty'

// State
import { userTokenUpdate } from '../../../store/actions/user'
import { getBanners } from '../../../store/actions/banners'
import { REACT_APP_API_URL, REACT_APP_SITE_KEY, REACT_APP_RESOURCE_URL } from '../../../shared/vars'

class BannerItem extends Component {
    constructor(props){
        super(props)
        this.state = {
            updateLoading: false,
            updateSuccess: '',
            updateErrors: {},
            deleteLoading: false,
            banner: this.props.banner
        }
    }

    handleInputChange(event){
        event.preventDefault()
		this.setState({
			banner: {
                ...this.state.banner,
                [event.target.id]: event.target.value
            }
		})
    }

    handleKeyPress(event, item_id){
		if (event.key === 'Enter'){
			this.handleSubmit()
		}
    }

    handleSubmit(){
        const { banner } = this.state
        const { user } = this.props

        this.setState({
            updateSuccess: '',
            updateErrors: {},
            updateLoading: true
        })

        const token = user.token
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token }
        return axios.post(REACT_APP_API_URL + 'banners/' + banner.id, banner, { headers: AUTH_HEADER })
		.then((response) => {
            if(response.status !== 200 || (response.data.status && response.data.status !== 200)){
                this.setState({
                    updateLoading: false,
                    updateErrors: !isEmpty(response.data.errors) ? response.data.errors : { general: response.data.message }
                })
            }else{
                this.setState({
                    updateLoading: false,
                    updateSuccess: response.data.message
                })

                this.props.userTokenUpdate('admin', response.data.token)
            }
		})
		.catch((err) => {
            if(err.response){
                this.setState({
                    updateLoading: false,
                    updateErrors: { general: err.response.data.error ? err.response.data.error : err.response.data.message }
                })
            }else{
                this.setState({
                    updateLoading: false,
                    updateErrors: { general: err.message }
                })
            }
		})
    }

    handleDelete(){
        const { banner } = this.state
        const { user } = this.props

        this.setState({
            updateSuccess: '',
            updateErrors: {},
            deleteLoading: true
        })

        const token = user.token
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token }
        return axios.delete(REACT_APP_API_URL + 'banners/' + banner.id, { headers: AUTH_HEADER })
		.then((response) => {
            if(response.status !== 200 || (response.data.status && response.data.status !== 200)){
                this.setState({
                    updateLoading: false,
                    updateErrors: !isEmpty(response.data.errors) ? response.data.errors : { general: response.data.message }
                })
            }else{
                this.setState({
                    updateLoading: false,
                    updateSuccess: response.data.message
                })

                this.props.userTokenUpdate('admin', response.data.token)
                this.props.getBanners()
            }
		})
		.catch((err) => {
            if(err.response){
                this.setState({
                    updateLoading: false,
                    updateErrors: { general: err.response.data.error ? err.response.data.error : err.response.data.message }
                })
            }else{
                this.setState({
                    updateLoading: false,
                    updateErrors: { general: err.message }
                })
            }
		})
    }

    render() {
        const { sizes, href, alt } = this.state.banner
        const { updateErrors, updateSuccess } = this.state

        return (
            <div className="form-field grouped-field">
                <div>
                    {sizes.full &&
                        <div className="image-preview-container">
                            <div className="text-section">
                                <div>Full Size</div>
                            </div>
                            <div className="image-display">
                                <img src={REACT_APP_RESOURCE_URL + sizes.full.src} alt={REACT_APP_RESOURCE_URL + sizes.full.src} />
                            </div>
                        </div>
                    }
                    
                    {sizes.mobile &&
                        <div className="image-preview-container">
                            <div className="text-section">
                                <div>Mobile</div>
                            </div>
                            <div className="image-display">
                                <img src={REACT_APP_RESOURCE_URL + sizes.mobile.src} alt={REACT_APP_RESOURCE_URL + sizes.mobile.src} />
                            </div>
                        </div>
                    }
                </div>

                <div className="form-field">
                    <label>URL</label>

                    {updateErrors.href &&
                        <div className="error msg_animate">{updateErrors.href}</div>
                    }
                    <input type="url" id="href" value={href} placeholder="http://www.website.com"
                        onKeyPress={e => this.handleKeyPress(e)}
                        onChange={event => this.handleInputChange(event)}
                    />
                </div>

                <div className="form-field">
                    <label>Alt</label>

                    {updateErrors.alt &&
                        <div className="error msg_animate">{updateErrors.alt}</div>
                    }
                    <input type="text" id="alt" value={alt} placeholder="Image Alternate Text"
                        onKeyPress={e => this.handleKeyPress(e)}
                        onChange={event => this.handleInputChange(event)}
                    />
                </div>

                <div className="btn_container">
                    {updateErrors.general &&
                        <div className="error msg_animate">{updateErrors.general}</div>
                    }
                    {updateSuccess && <div className="success msg_animate">{updateSuccess}</div>}
                    <button className={'btn update-btn' + (this.state.updateLoading ? ' loading' : '')} onClick={() => this.handleSubmit()} disabled={this.state.updateLoading || this.state.deleteLoading}><span>Update</span></button>
                    <button className={'btn delete-btn' + (this.state.deleteLoading ? ' loading' : '')} onClick={() => this.handleDelete()} disabled={this.state.updateLoading || this.state.deleteLoading}><span>Delete</span></button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
	return {
		user: state.user.admin
	}
}

export default connect(mapStateToProps, { userTokenUpdate, getBanners })(BannerItem)



// WEBPACK FOOTER //
// ./src/components/admin/banners/BannerItem.js